import React, { useRef, useState } from "react";
import '../styles/mrnsearch.css';
import enterOtpBg from '../assets/images/patient-image.jpg';
import PrimaryButton from "./inputs/PrimaryButton";
import { Api } from "../api/Api";
import { getLogo, parseJwt } from "../helpers/Helpers";
import { useAuth } from "../context/AuthContext";
import { showToast } from "../helpers/UIHelper";
import NonPatientDetail from "./NonPatientDetail";

const MRNSearch = (props) => {
    const [logging, setLogging] = useState(false);
    const [mrn, setMrn] = useState('');
    const [isNonPatient, setIsNonPatient] = useState(false);
    const Auth = useAuth();
    const [buttonLoading, setButtonLoading] = useState(false);
    const login = () => {
        debugger;
        setLogging(true);
        Api.authenticateMRN(props.mobile, mrn).then((resp) => {
            if (resp.status===200) {
                const { accessToken } = resp.data;
                const data = parseJwt(accessToken);
                if (resp.data.patients.length===0) {
                    showToast('error', 'No patients found with the entered UHID.')
                    return;
                }
                data.patients = resp.data.patients;
                const authenticatedUser = { data, accessToken };
                Auth.userLogin(authenticatedUser);
                if (!Auth.userIsAuthenticated()) {
                  showToast('error', 'Login failed, Please try again');
                  window.location.href = "/";
                } else {
                    window.location.href = "/";
                } 
            } else {
                showToast('error','Authentication Failed');
            }
        }).catch((e) => {
            showToast('error','Authentication Failed');
        }).finally(() => {
            setLogging(false);
        }) 
    }
    const loginNonPatient = () => {
        const { accessToken } = props.responseData;
        const data = parseJwt(accessToken);
        data.patients = [];
        const authenticatedUser = { data, accessToken };
        Auth.userLogin(authenticatedUser);
        if (!Auth.userIsAuthenticated()) {
            showToast('error', 'Login failed, Please try again');
            window.location.href = "/";
        } else {
            setIsNonPatient(true);
        }
    }
    const loginAgain = () => {
        setButtonLoading(true);
        Auth.userLogout();
        setButtonLoading(false);
    }
    return (
        <>
        {!isNonPatient ?
            <>
            <div className="mrn-login-container">
                <div className="image-container">
                    <img src={enterOtpBg} alt="login-bg"/>
                </div>
                <div className="text-container">
                    <div className="main-text">No patient found</div>
                    <div className="sub-text">Please enter an UHID to continue</div>
                </div>
                <div className="bottom-container">
                    <div className="form-container">
                        <div className="entry-field-container">
                            <input type="text" className="mrn-field" value={mrn} onChange={(e) => { setMrn(e.target.value); }}/>
                        </div>
                    </div>
                    <div className="form-container">
                        <PrimaryButton label="Continue" isLoading={logging} onClick={login} />    
                    </div>
                    <div className="form-container">
                        <span className="non-registered">Don't have a UHIUD?</span> 
                        <span className="link" onClick={() => { loginNonPatient(); }}>Click here!</span>       
                    </div>
                    <div className="form-container">
                        <PrimaryButton isLoading={buttonLoading} secondary={true} label="Use Another Number" onClick={() => { loginAgain(); }} />
                    </div>
                </div>
                <div className="logo-container">
                    {getLogo()}
                </div>
            </div >
            </>
            :
            <>
                <NonPatientDetail mobileNo={props.mobile} responseData={props.responseData} />
            </>
            }
        </>
    )
}
export default MRNSearch;